import React, { Component } from "react"
import bowser from "bowser"

import { Flex, Box } from "grid-styled"

import { Footer, LinkStyled, SiteInfo } from "../styled-components"

class PageFooter extends Component {
  render() {
    return (
      <Footer>
        <hr />
        <Flex flexWrap="wrap">
          <Flex
            flexDirection="column"
            width={[1, 1 / 2, 1 / 4]}
            alignItems={["baseline", "baseline", "center"]}
            order={[1, 1, 1]}
          >
            <Box>
              <LinkStyled to="/">
                &copy; STEPHAN ANDERS FOTOGRAFIE
                <br />
                <br />
              </LinkStyled>
            </Box>
          </Flex>
          <Flex
            flexDirection="column"
            width={[1, 1 / 2, 1 / 4]}
            alignItems={["baseline", "baseline", "center"]}
            order={[2, 2, 2]}
          >
            <Box>
              Fotografie aus <LinkStyled to="/koeln">Köln</LinkStyled>
              <br />
              national & international
              <br />
              <br />
            </Box>
          </Flex>
          <Flex
            flexDirection="column"
            width={[1, 1 / 2, 1 / 4]}
            alignItems={["baseline", "baseline", "center"]}
            order={[3, 3, 3]}
          >
            <Box>
              01575 – 3839427
              <br />
              info@fotografie-anders.com
              <br />
              <br />
            </Box>
          </Flex>
          <Flex
            flexDirection="column"
            width={[1, 1 / 2, 1 / 4]}
            alignItems={["baseline", "baseline", "center"]}
            order={[4, 4, 4]}
          >
            <Box>
              <SiteInfo>
                <LinkStyled to="/impressum">Impressum</LinkStyled>
                <LinkStyled to="/datenschutz">Datenschutz</LinkStyled>
                <LinkStyled to="/sitemap">Sitemap</LinkStyled>
                <p>Browser {bowser.name + " " + bowser.version}</p>
              </SiteInfo>
            </Box>
          </Flex>
        </Flex>
      </Footer>
    )
  }
}

export default PageFooter



// WEBPACK FOOTER //
// ./src/partials/PageFooter.js